module.exports = "/static/assets/8e6e65fc01177b14d8bc730e91adfad6.png";